import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import { Field, Form, useForm } from '../../form'
import classNames from 'classnames'
import Button from '@material-ui/core/Button'
import { Snackbar } from '@material-ui/core'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import { referralProgramValidate } from '../../containers/validate'

/**
 *
 * @author Huong Nguyen
 */

class ReferralCodeComponent extends React.Component {
  render() {
    return <ReferralCode {...this.props} />
  }
}

const styles = (theme) => ({
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontSize: '14px'
  },
  resize: {
    fontSize: '14px'
  },
  box: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  textBox: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '10px'
    }
  }
})

const defaultValues = {
  email: ''
}

const ReferralCode = ({
  classes,
  sendReferral,
  closeRererralSnackbar,
  showSnackBar,
  showFailSnackBar,
  emailExist
}) => {
  const form = useForm({
    name: 'referralEmail',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    resetOnSubmit: false,
    validator: referralProgramValidate
  })

  const { control } = form

  function onSubmit(values) {
    sendReferral(values)
  }
  return (
    <Translation>
      {(t) => {
        return (
          <div className="panel-body">
            <div>
              <p>
                <b>{t('referral.p2')}</b>
              </p>
              <br />
              <p>{t('referral.p3')}</p>
              <p>
                <b>{t('referral.p4')}</b> {t('referral.p5')}
              </p>
              <br />
              <p>
                <b>{t('referral.p6')}</b>
              </p>
              <p>{t('referral.p7')}</p>
              <p>{t('referral.p8')}</p>
              <p>
                <b>{t('referral.p9')}</b>
              </p>
              <Form {...form}>
                <div style={{ display: 'flex' }} className={classNames(classes.box)}>
                  <div className={classNames(classes.textBox)}>
                    <Field
                      label={t('referral.label1')}
                      name="email"
                      inputType="textfield"
                      className={classNames(classes.textField, classes.resize)}
                      control={control}
                      style={{ width: '300px'}}
                      helperTextStyle={{ marginTop: '0px', height: '0px' }}
                    />
                  </div>
                  <div
                    style={{
                      marginTop: 'auto',
                      paddingLeft: '20px'
                    }}
                  >
                    <Button type="submit" variant="contained">
                      {t('referral.btn1')}
                    </Button>
                  </div>
                </div>
              </Form>
              <Snackbar
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center'
                }}
                open={showSnackBar}
                autoHideDuration={4000}
                onClose={() => {
                  closeRererralSnackbar()
                }}
              >
                <MySnackbarContentWrapper
                  variant="success"
                  message={t('referral.msg1')}
                  onClose={() => {
                    closeRererralSnackbar()
                  }}
                />
              </Snackbar>
              <Snackbar
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center'
                }}
                open={showFailSnackBar}
                autoHideDuration={4000}
                onClose={() => {
                  closeRererralSnackbar()
                }}
              >
                <MySnackbarContentWrapper
                  variant="error"
                  message={t('referral.msg2')}
                  onClose={() => {
                    closeRererralSnackbar()
                  }}
                />
              </Snackbar>
              <Snackbar
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center'
                }}
                open={emailExist}
                autoHideDuration={4000}
                onClose={() => {
                  closeRererralSnackbar()
                }}
              >
                <MySnackbarContentWrapper
                  variant="error"
                  message={t('referral.msg3')}
                  onClose={() => {
                    closeRererralSnackbar()
                  }}
                />
              </Snackbar>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

ReferralCodeComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ReferralCodeComponent)
